import React from "react";
import styles from "./CustomCheckBox.module.scss";

export enum CheckboxShape {
	square = "square",
	circle = "circle",
}

interface CustomCheckBoxProps {
	isChecked: boolean;
	checkboxShape?: CheckboxShape;
	onChange?: (isChecked: boolean) => void;
	labelWidget?: React.ReactNode;
	className?: string;
}

export const CustomCheckBox: React.FC<CustomCheckBoxProps> = ({ isChecked, checkboxShape = CheckboxShape.square, onChange, labelWidget, className }) => {
	const handleClick = () => onChange?.(!isChecked);

	return (
		<span
			className={`${styles.wrapper} ${className ?? ""}`}
			onClick={onChange ? handleClick : undefined}
			role={onChange ? "checkbox" : undefined}
			aria-checked={onChange ? isChecked : undefined}
			tabIndex={onChange ? 0 : undefined}
		>
			<span className={`${styles.box} ${checkboxShape === CheckboxShape.circle ? styles.circle : styles.square} ${isChecked ? styles.checked : ""}`}>
				{isChecked && (
					<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden>
						<path d="M1.5 5L3.8 7.5L8.5 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				)}
			</span>
			{labelWidget && <span className={styles.label}>{labelWidget}</span>}
		</span>
	);
};
